module.exports = __webpack_public_path__ + "static/img/hb_55-min.2e47862.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_55-min.png
// module id = zEI3
// module chunks = 1